<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import CheckModal from "@/components/CheckModal";
import CustodiaHistoriasAPI from "@/services/standards/custodiaHistorias/custodiaHistoriasAPI";
import Table from "@/components/standard/Induction/components/InductionTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";

/**
 * Basic Tables component
 */
export default {
  page: {
    title:
      "3.1.5 Custodia de historias clínicas ocupacionales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title:
        "3.1.5 Custodia de historias clínicas ocupacionales",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Custodia de historias clínicas ocupacionales",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/custodia-historias`,
        },
        {
          text: "Editar",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: null,
      file: null,
      file2: null,
      custodia: {
        application_date: null,
        provider_evaluations: null,
        certificate: null,
        security_license: null,
        observations: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      company: null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      item: null,
      itemData: null,
    };
  },
  validations: {
    custodia: {
      provider_evaluations: {
        required,
      },
      application_date: {
        required,
      },
    },
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(27)
        .then((response) => {
          this.itemData = response;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.custodia.certificate)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.5/${this.$route.params.id}/certificado/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.5/${this.$route.params.id}/certificado/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.custodia.certificate = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async uploadDocument2() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.custodia.security_license)
        } else {
          name = this.file2.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.5/${this.$route.params.id}/licencia/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.5/${this.$route.params.id}/licencia/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file2);
          if (result) {
            this.custodia.security_license = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getShow() {
      CustodiaHistoriasAPI.getShow(this.$route.params.id)
        .then((response) => {
          this.custodia = {
            application_date: response.data.application_date,
            provider_evaluations: response.data.provider_evaluations,
            certificate: response.data.certificate,
            security_license: response.data.security_license,
            observations: response.data.observations,
            companies_id: response.data.companies_id,
          };
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      try {
        this.submitted = true
        this.loading1 = true
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.loading1 = false;
          return;
        } else {
          let doc1 = await this.uploadDocument();
          if (doc1) {
            let doc2 = await this.uploadDocument2();
            if (doc2) {
              CustodiaHistoriasAPI.update(this.$route.params.id, {
                application_date: this.custodia.application_date,
                provider_evaluations: this.custodia.provider_evaluations,
                certificate: this.custodia.certificate,
                security_license: this.custodia.security_license,
                observations: this.custodia.observations,
                companies_id: this.custodia.companies_id,
              })
                .then((response) => {
                  const itemChange = {
                    companies_id: this.companyID,
                    item_id: 27,
                    status: 'Pendiente',
                  };
                  newScoresAPI.calculateScores(itemChange)
                    .then((response) => {
                      this.loading1 = false;
                      setTimeout(() => {
                        Swal.fire({
                          title: "¡Éxito!",
                          text: "¡Informacion actualizada con éxito!",
                          type: "success",
                          icon: "success",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                      }, 1500);
                      this.$router.go(-1);
                    })
                    .catch((error) => {
                      this.loading = false
                      setTimeout(() => {
                        Swal.fire({
                          title: "Error",
                          text: "¡No se ha podido registrar!",
                          icon: "error",
                          type: "error",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                        window.location.reload();
                      }, 1000);
                      console.log(error);
                    });
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Error",
                  text: "¡No se ha podido registrar!, error licencia",
                  type: "warning",
                  icon: "warning",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
              }, 2000)
            }
          } else {
            this.loading1 = false
            setTimeout(() => {
              Swal.fire({
                title: "¡Error",
                text: "¡No se ha podido registrar!, error certificado",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            }, 2000)
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 27)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />
              <form class="form-group" @submit.prevent="update">
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2" label="Fecha solicitud certificado" label-for="trainingDate">
                    <b-form-input type="date" v-model="custodia.application_date" :class="{
                      'is-invalid': $v.custodia.application_date.$error && submitted,
                    }" id="trainingDate" :disabled="!allowAccess() || !getRole('Crear')">
                    </b-form-input>
                    <div v-if="submitted && $v.custodia.application_date.$error">
                      <small v-if="!$v.custodia.application_date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Proveedor evaluaciones médicas" label-for="trainingDate">
                    <b-form-input type="text" v-model="custodia.provider_evaluations" id="trainingDate"
                      :disabled="!allowAccess() || !getRole('Crear')">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2" label="Certificado de la custodia de la historia clínica"
                    label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="evidence" ref="evidence"
                      name="evidence" browse-text="Buscar" :placeholder="custodia.certificate
                        ? getFile(custodia.certificate)
                        : `Selecciona un archivo...`
                        " drop-placeholder="Suelta acá..." v-model="file"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Licencia en seguridad y salud en el trabajo del médico"
                    label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="evidence2" ref="evidence2"
                      name="evidence2" browse-text="Buscar" :placeholder="custodia.security_license
                        ? getFile(custodia.security_license)
                        : `Selecciona un archivo...`
                        " drop-placeholder="Suelta acá..." v-model="file2"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>
                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="custodia.observations" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" v-on:click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
